import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ScanLine } from "lucide-react";
import { api } from "../lib/api";
import { pcImageUrl, pcImageFallback } from "../lib/pcImage";
import { useCurrency } from "../context/CurrencyContext";

const resolveUrl = (url) => (url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

export default function RecentScansTicker() {
  const [cards, setCards] = useState(null);
  const { format } = useCurrency();

  useEffect(() => {
    api.get("/community/recent-scans").then((res) => setCards(res.data)).catch(() => setCards([]));
  }, []);

  if (!cards || cards.length < 4) return null;

  const Tile = ({ card, idx }) => (
    <Link
      to={`/collector/${card.owner_id}`}
      data-testid={`recent-scan-tile-${idx}`}
      title={`${card.name} — view this collector's binder`}
      className="group shrink-0 w-32 sm:w-36"
    >
      <div className="relative overflow-hidden rounded-xl border border-white/10 group-hover:border-[#A78BFA]/60 transition-colors shadow-lg shadow-black/40">
        <img
          src={pcImageUrl(resolveUrl(card.image), "240")}
          onError={pcImageFallback}
          alt={card.name}
          className="w-full aspect-[3/4] object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        {card.price != null && (
          <span className="absolute bottom-1.5 right-1.5 text-[11px] font-mono-plex font-bold text-[#F59E0B] bg-black/80 border border-white/15 rounded-md px-1.5 py-0.5">
            {format(card.price)}
          </span>
        )}
      </div>
      <p className="text-xs text-zinc-300 mt-1.5 truncate font-medium group-hover:text-white transition-colors">{card.name}</p>
    </Link>
  );

  return (
    <div data-testid="recent-scans-ticker" className="marquee-container relative w-full overflow-hidden">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4 px-6 max-w-7xl mx-auto">
        <ScanLine className="w-3 h-3 text-[#A78BFA]" /> Recently scanned by collectors — tap a card to browse their binder
      </div>
      <div className="marquee-track flex gap-4 px-4">
        {[...cards, ...cards].map((card, i) => (
          <Tile key={i} card={card} idx={i} />
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-20 sm:w-32 bg-gradient-to-r from-[#05060f] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-20 sm:w-32 bg-gradient-to-l from-[#05060f] to-transparent" />
    </div>
  );
}
